/**
 * <code>ContainmentType</code> 类用于定义空间物体位置关系。
 */
export class ContainmentType {

	/**不相交*/
	static Disjoint: number = 0;
	/**包含*/
	static Contains: number = 1;
	/**相交*/
	static Intersects: number = 2;

}


